import commonPasswordsArray from '@/common-passwords.json';
const commonPasswords = new Set(commonPasswordsArray);

const errorMessages = {
  consecutiveCharsCase:
    'Das Passwort darf keine aufeinanderfolgenden gleichen Zeichen enthalten (z.B. AAA).',
  commonPasswordCase:
    'Das Passwort ist zu unsicher. Wählen Sie ein anderes Passwort.',
  passwordsNotEqualCase:
    'Passwort und Passwortwiederholung müssen übereinstimmen.',
};

const consecutiveCharacters = (value: string) => {
  const pattern = new RegExp(/(.)\1\1/);
  const entry = pattern.test(value);
  return entry;
};

export const passwordValidate = (password: string): boolean | string => {
  const isPasswordCommon = commonPasswords.has(password.toLowerCase());
  if (isPasswordCommon) {
    return errorMessages.commonPasswordCase;
  }

  const isConsecutiveChars = consecutiveCharacters(password);
  if (isConsecutiveChars) {
    return errorMessages.consecutiveCharsCase;
  }

  return true;
};

export const confirmPasswordValidate = (
  currentPassword: string,
  comparingPassword: string,
): boolean | string => {
  const areEqual = currentPassword === comparingPassword;
  return areEqual || errorMessages.passwordsNotEqualCase;
};
